// ═══════════════════════════════════════════════════════════════
// OpenGov EMC — useMyOrg Hook
// Resolves the logged-in user's MainStreet organization
// ═══════════════════════════════════════════════════════════════

import { useMemo } from 'react';
import { useAuthStore } from '../store/authStore';
import { useMainStreetStore } from '../store/mainstreetStore';
import type { MSOrganization } from '../store/mainstreetStore';

export function useMyOrg(): MSOrganization | null {
  const user = useAuthStore(s => s.user);
  const organizations = useMainStreetStore(s => s.organizations);

  return useMemo(() => {
    if (!user?.email || organizations.length === 0) return null;
    const email = user.email.toLowerCase();

    // Match on org email field
    const byEmail = organizations.find(
      org => org.email?.toLowerCase() === email
    );
    if (byEmail) return byEmail;

    // Match on primaryContact containing user email
    const byContact = organizations.find(
      org => org.primaryContact?.toLowerCase().includes(email)
    );
    if (byContact) return byContact;

    return null;
  }, [user?.email, organizations]);
}
